import {
  Breadcrumb,
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Col,
  message, // Import message dari Ant Design
} from "antd";
import { SettingFilled } from "@ant-design/icons";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/User.context";
import { useHttp } from "../../../utils/DataHendler";
import dayjs from "dayjs"; // Ganti moment dengan dayjs

export const ProfileEdit = () => {
  let navigate = useNavigate();
  let profileObj = {
    name: "",
    phone: "",
    nik: "",
    email: "",
    birthdate: null, // Gunakan null sebagai nilai default
  };
  const { patchData, getData } = useHttp();

  const [profile, setProfile] = useState(null);
  const [input, setInput] = useState(profileObj);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(UserContext);
  const [form] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getData("/profile", {}, true);
      let data = response.data;
      setProfile(data);

      // Konversi birthdate ke format dayjs jika ada
      const formattedBirthdate = data.birthdate
        ? dayjs(data.birthdate) // dayjs dapat menangani format YYYY-MM-DD secara otomatis
        : null;

      form.setFieldsValue({
        name: data.name,
        phone: data.phone,
        nik: data.nik,
        email: data.email,
        birthdate: formattedBirthdate, // Set nilai birthdate sebagai objek dayjs
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Failed to fetch profile data:", error);
      message.error("Failed to load profile data. Please try again."); // Notifikasi gagal memuat data
    }
  };

  useEffect(() => {
    if (profile === null) {
      fetchData();
    }
  }, [profile, form]);

  const onFinish = async (values) => {
    let { name, nik, email, phone, birthdate } = values;

    setLoading(true);

    try {
      await patchData(
        "/profile",
        {
          name: name,
          phone: phone,
          email: email,
          nik: nik,
          birthdate: birthdate?.format("YYYY-MM-DD"), // Format tanggal menggunakan dayjs
        },
        {},
        true
      );

      setLoading(false);
      message.success("Profile updated successfully!"); // Notifikasi sukses
      navigate(-1); // Kembali ke halaman sebelumnya
    } catch (error) {
      setLoading(false);
      console.error("Error updating profile:", error);
      message.error("Failed to update profile. Please try again."); // Notifikasi gagal
    }
  };

  function FormEdit() {
    return (
      <div
        style={{
          background: "white",
          margin: "10% 10% 10% 10%",
          padding: 30,
          borderRadius: 20,
          textAlign: "left",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px",
        }}
      >
        <h1>Edit Profile</h1>
        <br />
        <Row justify="left">
          <Col xs={24} sm={22} md={18} lg={14}>
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              autoComplete="off"
              style={{ textAlign: "left" }}
            >
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Input Your Name!",
                  },
                ]}
              >
                <Input disabled={loading} />
              </Form.Item>
              <Form.Item
                label="Birthdate"
                name="birthdate"
                rules={[
                  {
                    required: true,
                    message: "Input Your Birthdate!",
                  },
                ]}
              >
                {/* DatePicker akan menerima objek dayjs sebagai nilai */}
                <DatePicker disabled={loading} needConfirm />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: "Input Your Email!",
                  },
                ]}
              >
                <Input disabled={loading} />
              </Form.Item>
              <Form.Item
                label="NIK"
                name="nik"
                rules={[
                  {
                    required: true,
                    message: "Input Your NIK!",
                  },
                ]}
              >
                <Input disabled={loading} />
              </Form.Item>
              <Form.Item
                label="Phone Number"
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Input Your Phone Number!",
                  },
                ]}
              >
                <Input disabled={loading} />
              </Form.Item>
              <Divider />
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                disabled={loading}
                style={{
                  height: 40,
                  borderRadius: 5,
                  borderColor: "#088395",
                }}
              >
                Update Profile
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <>
      <div>
        <Breadcrumb style={{ margin: "30px 0 0 100px" }}>
          <Breadcrumb.Item>
            <a
              onClick={() => {
                navigate("/user/profile");
              }}
            >
              Profile
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Profile Edit</Breadcrumb.Item>
        </Breadcrumb>
        <FormEdit />
      </div>
    </>
  );
};
